export default __webpack_public_path__ + "static/media/addContact.73daf857.png";